module.exports = __webpack_public_path__ + "img/whatsapp_white.b3d7854f.svg";